import React from 'react';

import { IDocument, IGroup, IGroupMessage, IMeeting } from '../../store/group/groupState';

import AttachmentFavorite from '../../components/shared/attachmentlink/AttachmentFavorite';
import DocumentFavorite from '../../components/shared/attachmentlink/DocumentFavorite';
import AttachmentIcon from '../../components/shared/attachmentlink/AttachmentIcon';
import AttachmentLink from '../../components/shared/attachmentlink/AttachmentLink';
import Tags from '../../components/shared/tags/Tags';

enum FavoriteType {
    Attachment,
    Document
}

interface IFavorite extends IDocument {
    groupId: string;
    messageId?: string;
    meetingId?: string;
    favoriteType: FavoriteType;
}

interface IOwnProps {
    title: string;
    group: IGroup | undefined;
    messages: IGroupMessage[];
    meetings: IMeeting[];
}

type Props = IOwnProps;

class Documents extends React.Component<Props, {}> {
    public render() {
        const attachments = this.props.messages && this.props.messages.length > 0 ? this.props.messages.reduce((prev, current) => prev.concat(current.attachments.filter(a => a.isFavorite).map(a => ({ ...a, messageId: current.messageId, groupId: current.groupId, favoriteType: FavoriteType.Attachment }))), [] as IFavorite[]) : [];
        const documents = this.props.meetings && this.props.meetings.length > 0 ? this.props.meetings.reduce((prev, current) => prev.concat(current.documents.filter(d => d.isFavorite).map(d => ({ ...d, meetingId: current.meetingId, groupId: current.groupId, favoriteType: FavoriteType.Document }))), [] as IFavorite[]) : [];
        const favorites = attachments.concat(documents);

        return this.props.group && this.props.group.enabled && favorites && favorites.length > 0 ? <section className="section">
            <div className="deck">
                <div className="w--md banner-title">
                    <h1>{this.props.title}</h1>
                </div>
            </div>
            <div className="deck">
                <div className="w--md">
                    <Tags alwaysVisible={true} isLarge={true} useOverflow={true}>
                        {favorites.sort((a, b) => a.fileName < b.fileName ? 1 : a.fileName > b.fileName ? -1 : 0).map(favorite => {
                            return <li key={favorite.id} className="tags__list__item">
                                <AttachmentLink className="button button--tag" document={favorite} title={favorite.fileName}>
                                    {favorite.favoriteType === FavoriteType.Attachment ?
                                        <AttachmentFavorite id={favorite.id} groupId={favorite.groupId} messageId={favorite.messageId!} isFavorite={favorite.isFavorite} />
                                        :
                                        <DocumentFavorite id={favorite.id} groupId={favorite.groupId} meetingId={favorite.meetingId!} isFavorite={favorite.isFavorite} />
                                    }
                                    <AttachmentIcon mimeType={favorite.mimeType} />
                                    {favorite.fileName}
                                </AttachmentLink>
                            </li>;
                        })}
                    </Tags>
                </div>
            </div>
        </section> : null;
    }
}

export default Documents;